/// when the user is not logged in, the header is not fully opaque
export function hasFullOpacity(location: string): boolean {
    return location.indexOf('terms-and-conditions') > -1 ||
    location.indexOf('privacy-policy') > -1 ||
    location.indexOf('our-mission') > -1
}
